import { connect } from 'react-redux';
import { toStandardDate } from '../../../helpers/dates';
import {
  getLocationZoneOptions,
  getDonorOptions,
  getIsFetchingLocationZoneOptions,
  getIsFetchingDonorOptions,
  getIsSaving,
  getIsSaved
} from '../../../redux/Inventory/selectors/components/adjust-item-form';
import {
  adjustInventoryItem,
  fetchInventoryItemAvailability,
  fetchInventoryLocationZoneOptions,
  fetchInventoryDonorOptions
} from '../../../redux/Inventory/sagas/routines';
import InventoryAdjustItemForm from '../../../components/inventory/AdjustItemForm';

function mapStateToProps(state, props) {
  return {
    ...props,
    zoneOptions: getLocationZoneOptions(state),
    donorOptions: getDonorOptions(state),
    isFetchingZones: getIsFetchingLocationZoneOptions(state),
    isFetchingDonors: getIsFetchingDonorOptions(state),
    isSaving: getIsSaving(state),
    isSaved: getIsSaved(state)
  };
}

function mapDispatchToProps(dispatch, { item: { id } }) {
  return {
    onInit: () => {
      dispatch(fetchInventoryDonorOptions());
      dispatch(fetchInventoryLocationZoneOptions());
    },
    onSubmit: ({ performedOn = null, ...formData }) => {
      const body = performedOn
        ? { ...formData, performedOn: toStandardDate(performedOn) }
        : formData;
      dispatch(adjustInventoryItem({ id, body }));
    },
    onSaved: () => {
      dispatch(fetchInventoryItemAvailability(id));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryAdjustItemForm);
